import { getIconPath } from "../config";
import shortUuid from 'short-uuid'

export const formatDateToYYYYMMDDHHMMSS = (date) => {
    const inputDate = new Date(date);
    const formattedDate = `${inputDate.getFullYear()}-${String(inputDate.getMonth() + 1).padStart(2, '0')}-${String(inputDate.getDate()).padStart(2, '0')} ${String(inputDate.getHours()).padStart(2, '0')}:${String(inputDate.getMinutes()).padStart(2, '0')}:${String(inputDate.getSeconds()).padStart(2, '0')}`;
    return formattedDate;
}


export const findTriggerEvent = ({transaction, events, clusterlets}) => {
    try {
        const firstEvent = transaction?.events?.sort((a, b) => a.order - b.order)[0];
        if(firstEvent === undefined){
          throw  new Error(`Cannot find frst event in the transaction '${transaction?._id}'`)
        }

        const eventData = firstEvent !== undefined ? events.find(ev => ev._id === firstEvent.id) : null;
        if(eventData === undefined){
          throw new Error(`Event data with id '${firstEvent.id}' not found`)
        }
        if(eventData){
            const eventSrc = clusterlets.find(clstr => clstr._id === eventData.src)
            // console.log({eventSrc})
            if(eventSrc === undefined){
              throw new Error(`Couldn't find the event source for the event with id '${eventData?._id}' `);
            }
            if(eventSrc?.type === 1){
                return eventData;
            } else{
              throw new Error(`Source of the first event in the transaction is not a delegate`)
            }
        }

    } catch (error) {
        console.error(`Finding triggering event failed for transaction "${transaction?._id}". ${error.message} `);
        return null;   
    }
}

export const getTimeAgo = (time) => {
  const timestamp = new Date(time).getTime();
  const now = Date.now();

  const diffInSeconds = Math.floor((now - timestamp) / 1000);

  if (diffInSeconds < 1) {
    return 'Just now';
  }

  if (diffInSeconds < 60) {
    return `${diffInSeconds} second${diffInSeconds === 1 ? '' : 's'} ago`;
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);

  if (diffInMinutes < 60) {
    return `${diffInMinutes} min${diffInMinutes === 1 ? '' : 's'} ago`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);

  if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours === 1 ? '' : 's'} ago`;
  }

  const diffInDays = Math.floor(diffInHours / 24);

  if (diffInDays < 30) {
    return `${diffInDays} day${diffInDays === 1 ? '' : 's'} ago`;
  }

  const diffInMonths = Math.floor(diffInDays / 30);

  if (diffInMonths < 12) {
    return `${diffInMonths} month${diffInMonths === 1 ? '' : 's'} ago`;
  }

  const diffInYears = Math.floor(diffInMonths / 12);

  return `${diffInYears} year${diffInYears === 1 ? '' : 's'} ago`;
};

export const findTransactionAssociatedConstructs = ({transactionId, transactions, events, clusterlets}) => {
  const transaction = transactions?.find(transaction => transaction._id === transactionId);
  
  const filteredEvents = events?.filter(event => transaction?.events.map(item => item.id).includes(event._id))

  const filteredClusterlets = clusterlets?.filter(clusterlet => transaction?.clusterlets.map(item => item.id).includes(clusterlet._id))

  return {transaction, events: filteredEvents, clusterlets: filteredClusterlets}
}


/**
 * @param {Root Element} payloadDiv 
 * @param {Schema of the JSON Editor} data 
 * @param {Root level element data-shemapath value} baseSchema 
 * This function helps to make outline and also to give a background color to each section in the form
 */
export const makeOutlines = (payloadDiv, data, baseSchema) => {
    const paths = getSchemaPaths(data,baseSchema,'') || [];

    paths.forEach(item => {
        const group = payloadDiv.querySelector(`div[data-schemapath="${item}"]`)
        if(group){
            const cardBody = group.querySelector('.card-body');
            if(cardBody){
              cardBody.style.cssText = `border: 2px solid rgba(0,0,0,0.1) !important;
              padding: 0.5rem !important;
              margin-left: 0 !important;
              background: #F5FAFA !important;
              `
            }
        }
    })
}

/**
 * @param {Schema of the JSON Editor} data 
 * @param {Root level element data-shemapath value} baseSchema 
 * @param {Value that need to append with the baseSchema} appendBase 
 * @param {Array of dataschema paths. Initial Value is []} paths 
 * @returns An array that includes all the data-schemapath of sections
 */
const getSchemaPaths = (data, baseSchema, appendBase, paths = []) => {
    let base = `${baseSchema}${appendBase !== '' ? `.${appendBase}` : ''}`;
    const keys = (!Array.isArray(data) && typeof data === 'object') ? Object.keys(data) : [];

    keys.forEach((key) => { 
      if (!(data[key]?.hasOwnProperty("value"))) {
        paths.push(base + "." + key);
        getSchemaPaths(data[key], baseSchema , `${appendBase !== '' ? appendBase + '.' : ''}${key}`, paths);
      }
    });
    return paths
};


export const getTestcaseNameFromURL = (search) => {
    const query = new URLSearchParams(search);
    return query.get('testcase')
}

/**
 * This function will check all the type and data is matching and return the errors if not matching
 * @param {expected array of object and each object should contain key, value and type fields} data 
 * @returns an array of errors {key: '', message: ''}
 */
export const validateFormValueType = (data) => {
    const errors = [];
    data.forEach((item) => {
      const errorStructure = {
        message: `Invalid value`,
        key: item.key,
      };
  
      if (
        item.type === "hbx_regex" ||
        item.type === "hbx_randomIp" ||
        item.type === "hbx_randomNumber"
      ) {
        try {
          const value = item.value.replace(/'/g, '"');
          if(typeof value !== "string" || (!value.includes("{") || !value.includes("}"))){
              errors.push(errorStructure);
          }else{
              JSON.stringify(JSON.parse(value));
          }
        } catch (error) {
          errors.push(errorStructure);
        }
      } else if (
        [
          "string",
          "datetime",
          "timestamp",
          "table-button",
          "octetstring",
        ].includes(item.type) && 
        typeof item.value !== "string"
      ) {
          errors.push(errorStructure);
      } else if (
        [
          "number",
          "int8",
          "int16",
          "int34",
          "int64",
          "uint8",
          "uint16",
          "uint32",
          "uint64",
          "double",
          "float",
        ].includes(item.type) &&
        isNaN(item.value)
      ) {
        errors.push(errorStructure);
      } else if ((item.type === "boolean" || item.type === "bool") && (item.value !== "true" && item.value !== "false")) {
        errors.push(errorStructure);
      }
    });
  
    return errors;
};

export const formatFetchedCustomIcons = (data, iconPath=false) => {
  try {
    const hasExtension = (filename) => /\.[^/.]+$/.test(filename);

  if(data?.iconSource === 'library'){
    return hasExtension(data?.icon) ? `/cached_icons/${data?.icon}` : `/cached_icons/${data?.icon}.svg`;
  }else if(data?.isCustomIcon || data?.iconSource === "custom"){
    return{
      filePath: `${iconPath ? iconPath : getIconPath() }${data?.icon}`,
      data: {
        assetName: data?.assetName,
        uuid: hasExtension(data?.icon) ? data?.icon : `${data?.icon}.svg`
      }
    }
  }else if(data?.icon){
    return hasExtension(data?.icon) ? `/node_icons/${data?.icon}` : `/node_icons/${data?.icon}.svg`;
  }


  } catch (error) {
    console.error(`Formatting fetched custom icon failed. ${error}`);
    return null;
  }
}

export const generateIconFileName = (icon) => {
  try {
  if(icon?.source){
    return `${icon?.id}.${icon?.file_extension}`
  }else if(icon?.data){
      if(icon?.data?.assetName){
        const splitted = icon?.data?.assetName?.split('.');
        const ext = splitted[splitted?.length - 1];
        return splitted ? `${icon?.data?.uuid}.${ext}` : icon?.data?.uuid
      }else{
        return icon?.data?.uuid
      }
  }else{
      if(typeof icon == "string" && icon?.includes("/node_icons")){
        return icon.replace("/node_icons/", "").replace(".svg", "");
      }else{
        const url = window.location.origin
        console.log({url})
        return icon.replace("/cached_icons/", "").replace(url, "");
      }
  }

  } catch (error) {
    console.error(`Generating icon filename failed. ${error}`);
    return null
  }
}

export const validateNonAsciiChars = (str) => {
  // Match non-ASCII characters (anything outside the range of 0-127)
  const nonAscii = str.match(/[^\x00-\x7F]/g);
  
  // If there are no non-ASCII characters, return true
  if (!nonAscii) {
    return true;
  }

  // Return non-ASCII characters as a comma-separated string
  return `Non-ASCII characters (${nonAscii.join(',')}) present in the field`;
}

export const isValidSimpleIdentifier = (str) => {
  return /^[a-zA-Z0-9_]*$/.test(str);
}


export const getFirstLetterOfEachWords = (inputString) => {
  // Split the string based on underscores
  let wordsWithUnderscores = inputString.split('_');
  // console.log({wordsWithUnderscores})

  // Split each word based on transition from lowercase to uppercase
  let words = wordsWithUnderscores.flatMap(word => word.split(/(?=[A-Z])/));

  // Extract the first character of each word
  let extractedLetters = words.map(word => word[0]);

  // Concatenate the extracted letters into a single string
  let result = extractedLetters.join('');

  return result.toLowerCase();
}



export const  convertObjectToArrays = (input)  => {
  const messages = [];
  const fields = [];
  const parentArray = [];

  function processNode(node, parentId = null, parentType = null) {
      const { name, type, children, ...rest } = node;
      const value = shortUuid.generate(); // Generate a short UUID for each node

      if (type === 'message') {
          const messageObject = { ...rest, label:name, type, value };
          messages.push(messageObject);
          parentArray.push({ id: value, type: 'message' });
      } else if (type === 'field') {
          const fieldObject = { 
              ...rest, 
              name, 
              type, 
              value, 
              parent: parentId ? [{ id: parentId, type: parentType }] : [] 
          };
          fields.push(fieldObject);
      }

      if (children && Array.isArray(children)) {
          children.forEach((child) => processNode(child, value, type));
      }
  }

  Object.values(input).forEach((cmd) => processNode(cmd));

  return { messages, fields, parentArray };
}

export const  findMessageAndFields = (messages, fields, id) => {
  // Find the main message object with the given id
  const message = messages.find(msg => msg.value === id);

  if (!message) {
      return { message: null, fields: [] }; // Return if message not found
  }

  // Helper function to recursively find child fields
  function getChildFields(parentId) {
      const childFields = fields.filter(field => field.parent[0]?.id === parentId);
      
      // Recursively gather children of each child field
      for (const childField of childFields) {
          childFields.push(...getChildFields(childField.value));
      }
      
      return childFields;
  }

  // Get all fields directly or indirectly related to the message
  const relatedFields = getChildFields(id);

  return { message, fields: relatedFields };
}

export const filterUniqueMessages = ({ existingMsgs, schemaMessages }) => {

  // Get the set of values from allMessages for quick lookup
  const allMessagesValues = new Set(existingMsgs.map(message => message.name));

  // Filter out the items in messageLists whose value is in allMessages
  const filteredMessageLists = schemaMessages.filter(
      message => !allMessagesValues.has(message.label)
  );

  return filteredMessageLists;
}

export const filterSchemaMessages = (allMessages = [], messagesFromSchema = [], dbArray = []) =>  {
    // console.log("filterSchemaMessages----------------------------------", )
    // console.log({allMessages, messagesFromSchema, dbArray})
  
    // Create a map from dbArray for quick lookup by name and _id
    const messagesFromSchemaSet = new Set(messagesFromSchema.map(message => message.label));

    const existingMessages = allMessages.filter(msg => messagesFromSchemaSet.has(msg.label)) || [];
      
    let existingDbMessages = dbArray?.filter(dbMsg =>  ( existingMessages?.map(item=> item?.value) )?.includes(dbMsg._id.toString()))

    const filteredExistingDbMessages = existingDbMessages?.filter(item => item?.fromschema === false);

    return filteredExistingDbMessages;

    
}

/**
 * Function to convert date string into local time
 * @param {string} dateString 
 * @returns Date in format year-month-day hours:minutes:seconds
 */
export const convertToLocalTime =  (dateString) => {
  let localDate = new Date(dateString);
  let year = localDate.getFullYear();
  let month = String(localDate.getMonth() + 1).padStart(2, '0');
  let day = String(localDate.getDate()).padStart(2, '0');
  let hours = String(localDate.getHours()).padStart(2, '0');
  let minutes = String(localDate.getMinutes()).padStart(2, '0');
  let seconds = String(localDate.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export const findIconSource = (iconData) => {
  try {
  console.log("findIconSource------", iconData)
  if(iconData.source || (typeof iconData == "string" && iconData?.includes("/cached_icons"))  ){
    return 'library'
  }else if(iconData?.data){
    return 'custom'
  }else{
    return 'built-in'
  }


  } catch (error) {
    console.error(`Finding icon filename failed. ${error}`);
    return null
  }
}

export const managePlatformSchemaNavigation = (errors, constructs) => {
  const location = window.location.pathname?.split('/');
  
  errors?.forEach(err => {
    if(err.entity === 'routingRule' && err.type !== 'info' && err.entityId){
      
      const rrdef = constructs?.routingRules?.find(rrdef => rrdef?._id === err.entityId);
      const event = constructs?.events?.find(event => event._id === rrdef?.attributes?.tcmd);
      const transaction = constructs?.transactions?.find(txn => {
        let events = txn.events?.map(item => item.id);
        return events?.includes(event?._id)
      });
      const delegate = constructs.clusterlets?.find(clusterlet => [event?.src, event?.dst].includes(clusterlet._id) && clusterlet.type == 1)
      
      if(transaction){
        err.path = `/blueprint/${location[2]}/${location[3]}/transaction/${transaction?._id}`
        err.focusElement = {
          id: event?._id,
          type: 'event',
          mode: 'edit',
          name: event?.name,
          transaction: transaction?._id,
          protocol: delegate?.attributes?.type,
          item: event,
          screen: "transaction",
          action: {
            id: rrdef?._id,
            action: "edit_rrdef"
          }
        }
        err.tabOnFocus = 2
      }
    }else if(err.entity === 'message'){
      const message = constructs?.messages?.find(message => message?._id == err.entityId)

      err.focusElement = {
        id: null,
        type: "event_types",
        action: {
          action: "edit_event_type",
          id: message?._id,
          item: message
        }
      }
      err.tabOnFocus = 0;
    }else if(err.entity === 'event'){
      const event = constructs?.events?.find(event => event._id === err.entityId);
      const transaction = constructs?.transactions?.find(txn => {
        let events = txn.events?.map(item => item.id);
        return events?.includes(event?._id)
      });
      const delegate = constructs.clusterlets?.find(clusterlet => [event?.src, event?.dst].includes(clusterlet._id) && clusterlet.type == 1)

      if(transaction && event){
        err.path = `/blueprint/${location[2]}/${location[3]}/transaction/${transaction?._id}`
        err.focusElement = {
          id: event?._id,
          type: 'event',
          mode: 'edit',
          name: event?.name,
          screen: "transaction",
          transaction: transaction?._id,
          protocol: delegate?.attributes?.type,
          item: event
        }
        err.tabOnFocus = 0
      }
    }else if(err.entity === 'testCase'){
      const testcase = constructs?.testCases?.find(t => t._id == err.entityId);
      if(testcase){
        err.path = `/blueprint/${location[2]}/${location[3]}/testsuite/${testcase?.testsuite_id}?testcase=${testcase?._id}`
      }
    }else if(err.entity === 'view'){
      if(err.entityId){
        err.path = `/blueprint/${location[2]}/${location[3]}/view/${err.entityId}`
      }
    }
  })

  return errors;
}


export const formatConstraintToDropdownValues = (value) => {
  try {
      if(value === undefined ){
        return null;
      }
      if(typeof value == "object"){
        return value;
      }

      const items = value.split(",");
      const options =  items?.map(item => ({label: item, value: item}) ); 
      return options;
  } catch (error) {
    console.error(`Formatting dropdown values failed. ${error}`);
    return [];
  }
}


export const formatGeneratedIconSourePath = (path) => {
  try {
    if(typeof path == "string"){
      return path;
    }
    return path?.filePath || "format_path_failed";
  } catch (error) {
    console.error("Formatting icon path failed. ", error)
    return "format_path_failed"
  }
} 

/**
 * Recursively builds enriched transaction elements, including clusterlets, events, invoked and nested transactions.
 *
 * @param {Object} params
 * @param {Object} params.transaction - The transaction to analyze.
 * @param {Array} params.allEvents - List of all events.
 * @param {Array} params.allClusterlets - List of all clusterlets.
 * @param {Array} params.allTransactions - List of all transactions.
 * @param {string} [params.name=null] - Optional name override for logging.
 * @returns {Object|null} - Enriched transaction elements or null on failure.
 */
export const getTransactionElements = ({ transaction, allEvents, allClusterlets, allTransactions, name = null }) => {
  const txnName = transaction?.name || name || transaction?._id || "Unknown";

  try {
    if (!transaction) return null;

    const result = {
      transaction,
      clusterlets: [],
      events: [],
      child_transactions: [],
      invoked_transactions: [],
    };

    const findClusterlet = (id) => allClusterlets?.find(item => item?._id === id);

    // -------------------
    // EVENTS
    // -------------------
    result.events = (transaction.events || [])
      .map(evtRef => {
        const eventObj = allEvents?.find(ev => ev?._id === evtRef?.id);
        if (!eventObj) return null;

        return {
          ...eventObj,
          order: evtRef?.order,
          source: findClusterlet(eventObj?.src),
          target: findClusterlet(eventObj?.dst)
        };
      })
      .filter(Boolean)
      .sort((a, b) => a.order - b.order);

    // -------------------
    // CLUSTERLETS
    // -------------------
    result.clusterlets = (transaction.clusterlets || [])
      .map(ref => {
        const base = allClusterlets?.find(cl => cl?._id === ref?.id);
        if (!base) return null;
        return {
          ...base,
          order: ref?.order
        };
      })
      .filter(Boolean)
      .sort((a, b) => a.order - b.order);

    // -------------------
    // INVOKED TRANSACTIONS
    // -------------------
    result.invoked_transactions = (transaction.invokedTransactions || [])
      .map(invRef => {
        const foundTxn = allTransactions?.find(txn => txn?._id === invRef?.id);
        if (!foundTxn) return null;

        return {
          ...foundTxn,
          order: invRef?.order,
          uuid: invRef?.uuid,
          parent: transaction?._id
        };
      })
      .filter(Boolean)
      .sort((a, b) => a.order - b.order);

    // -------------------
    // NESTED TRANSACTIONS (Recursive)
    // -------------------
    result.child_transactions = (transaction.nestedTransactions || [])
      .map(nestedRef => {
        const nestedTxn = allTransactions?.find(txn => txn?._id === nestedRef?.id);
        if (!nestedTxn) return null;

        const nestedElements = getTransactionElements({
          transaction: nestedTxn,
          allEvents,
          allClusterlets,
          allTransactions,
          name: nestedTxn?.name
        });

        return {
          ...nestedTxn,
          parent: transaction?._id,
          order: nestedRef?.order,
          events: nestedElements?.events || [],
          clusterlets: nestedElements?.clusterlets || [],
          invoked_transactions: nestedElements?.invoked_transactions || [],
          child_transactions: nestedElements?.child_transactions || []
        };
      })
      .filter(Boolean)
      .sort((a, b) => a.order - b.order);

    return result;
  } catch (error) {
    console.error(`Finding transaction elements failed for '${txnName}'. ${error}`);
    return null;
  }
};


export function generateMongoId() {
  const timestampHex = Math.floor(Date.now() / 1000).toString(16);
  let randomHex = '';
  for (let i = 0; i < 16; i++) {
    randomHex += Math.floor(Math.random() * 16).toString(16);
  }
  return timestampHex + randomHex;
}

export function collectChildren(allTransactions, allEvents, transactionId) {
  const result = [];

  const transactionMap = new Map();
  const eventMap = new Map();

  // Build maps for fast lookup
  for (const tx of allTransactions) {
    transactionMap.set(tx._id, tx);
  }
  for (const ev of allEvents) {
    eventMap.set(ev._id, ev);
  }

  function traverse(txId, parentId = null) {
    const transaction = transactionMap.get(txId);
    if (!transaction) return;

    // Process events
    for (const eventRef of transaction.events || []) {
      const ev = eventMap.get(eventRef.id);
      if (ev) {
        result.push({
          id: eventRef.id,
          parentId: txId,
          order: eventRef.order ?? null,
          type: "event",
          object: ev,
        });
      }
    }

    // Process nested transactions
    for (const nestedRef of transaction.nestedTransactions || []) {
      const nestedTx = transactionMap.get(nestedRef.id);
      if (nestedTx) {
        result.push({
          id: nestedRef.id,
          parentId: txId,
          order: nestedRef.order ?? null,
          type: "transaction",
          object: nestedTx,
        });

        // Recurse into this nested transaction
        traverse(nestedRef.id, txId);
      }
    }
  }

  traverse(transactionId); // Start from the given transaction ID

  return result;
}

function hasAtLeastTwoCommonIds(selected, invoked) {
  const importedIds = new Set(invoked.map(item => item.id));
  return selected.filter(item => importedIds.has(item.id)).sort((a, b) => a.order - b.order);
}


/**
 * Extracts the source and destination clusterlet IDs from events in a transaction.
 *
 * @param {Object} params
 * @param {Object} params.transaction - Transaction object containing ordered clusterlets.
 * @param {Object} params.child - Root node that may contain nested events.
 * @param {Array} params.allEvents - List of all available events.
 * @returns {Object} - Object containing `src` and `dst` clusterlet IDs.
 */
export function getSrcAndDstFromEvents({ transaction, child, allEvents, allTransactions, selectedTx }) {

  const transactionClusterlets = transaction?.clusterlets?.sort((a, b) => a?.order - b?.order) || [];

  // Recursively collect all event objects from the child tree
  const allTransactionEvents = [];
  const allInvoked  = [];

  const collectEvents = (children) => {
    children?.forEach(item => {
      if (item?.type === "event") {
        const eventObj = allEvents?.find(ev => ev?._id === item?.id);
        if (eventObj) allTransactionEvents.push(eventObj);
      } else if (item?.type === "nested" && Array.isArray(item?.children)) {
        collectEvents(item.children);
      }else if (item?.type === "invoked" ) {
        const txObj = allTransactions?.find(tx => tx?._id === item?.id);
        if (txObj) allInvoked.push(txObj);
      }
    });
  };

  collectEvents(child?.children || []);
  // console.log({allTransactionEvents})

  // If no events found, return first and last clusterlet as src/dst
  if (allTransactionEvents.length === 0 && allInvoked.length == 0) {
    return {
      src: transactionClusterlets[0]?.id || null,
      dst: transactionClusterlets[transactionClusterlets.length - 1]?.id || null
    };
  }

  // Gather all src/dst from events
  const eventClusterletIds = allTransactionEvents.flatMap(event => [event?.src, event?.dst]);

  allInvoked.forEach(invoked => {
    const commonCls = hasAtLeastTwoCommonIds(selectedTx.clusterlets, invoked.clusterlets)
    commonCls.forEach(cl => {
      if(cl.id) eventClusterletIds.push(cl.id)
    })
  })

  // Remove duplicates and map to clusterlets with order
  const uniqueClusterletsWithOrder = Array.from(new Set(eventClusterletIds))
    .map(id => {
      const clusterlet = transactionClusterlets.find(cl => cl?.id === id);
      return clusterlet ? { id: clusterlet.id, order: clusterlet.order } : null;
    })
    .filter(Boolean) // Remove nulls
    .sort((a, b) => a.order - b.order); // Sort by order

  return {
    src: uniqueClusterletsWithOrder[0]?.id || null,
    dst: uniqueClusterletsWithOrder[uniqueClusterletsWithOrder.length - 1]?.id || null
  };
}

export function getAllClusterletsFromEvents(items, parentTransaction) {
  const eventItems = items.filter(item => item.type === 'event');
  if (eventItems.length === 0 && parentTransaction.clusterlets.length == 0 ) return [];

  if(eventItems.length === 0 && parentTransaction.clusterlets.length > 0){
    let clusterletIds = parentTransaction.clusterlets.map(cl => cl.id)
    return clusterletIds;
  }

  const involvedIds = new Set();

  for (const item of eventItems) {
    const { src, dst } = item.object;
    if (src) involvedIds.add(src);
    if (dst) involvedIds.add(dst);
  }

  return Array.from(involvedIds);
}



export const getTransactionChildrenInOrder = ({transaction, allTransactions, allEvents, nested=false}) => {
  // console.log("getTransactionChildrenInOrder--------------------", {transaction, allTransactions, allEvents, nested})
    if(transaction === undefined){
      console.error("Finding transaction children failed")
    }

    // const deduplicateById = (array = [], type='') => {
    //   const seen = new Set();
    //   return array.filter(item => {
    //     const id = item?.id ?? item; // if it's a string or object with id
    //     if (seen.has(id)) return false;
    //     seen.add(id);
    //     return true;
    //   });
    // };
    const deduplicateById = (array = [], type = '') => {
      const seen = new Set();
      return array.filter(item => {
        // Use uuid if type is 'invoke', otherwise use id
        const key = type === 'invoked' ? item?.uuid ?? item : item?.id ?? item;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    };

    let invokedTransactions = deduplicateById(transaction?.invokedTransactions, "invoked") || [];
    let nestedTransactions = deduplicateById(transaction?.nestedTransactions) || [];
    let events = deduplicateById(transaction?.events) || [];
    let templateTransactions = deduplicateById(transaction?.templateTransactions) || [];

    let children = [...invokedTransactions?.map((i) => ({ ...i, type: 'invoked', parent: transaction?._id })), ...nestedTransactions?.map((n) => ({ ...n, type: 'nested', parent: transaction?._id })), ...events.map((e) => ({ ...e, type: 'event', parent:  transaction?._id })), ...templateTransactions?.map((i) => ({ ...i, type: 'template' }))] || [];
    
    // Filters children to only include those whose corresponding event or transaction exists.
    const eventIdsSet = new Set(allEvents?.map(item => item?._id) || []);
    const transactionIdsSet = new Set(allTransactions?.map(item => item?._id) || []);
    const filteredChildren = (children || []).filter(child => {
      if (!child?.id || !child?.type) return false;

      switch (child.type) {
        case "nested":
        case "invoked":
          return transactionIdsSet.has(child.id);
        case "event":
          return eventIdsSet.has(child.id);
        default:
          return true;
      }
    });
    // console.log({filteredChildren})

    filteredChildren.sort((a, b) => {
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;
    });

    children = filteredChildren?.map(item => {
      if(item?.type === "nested"){
        const txnData = allTransactions?.find(txn => txn?._id === item?.id)
        item.children = getTransactionChildrenInOrder({transaction: txnData, allTransactions, allEvents, nested:true})
      }
      return item;
    });

    
   

    
    return children;
   
}




export const generatePrefix = (input) => {
  const prefix = input
    .match(/[A-Z]/g) // Get all uppercase letters
    ?.join('') || input.charAt(0).toUpperCase(); // fallback to first char
  return prefix + '_';
}

/**
 * Flattens a tree structure into an array, removing the `children` property.
 *
 * @param {Array} array - The input tree array.
 * @returns {Array} - A flat array of nodes without `children`.
 */
export function flattenTree(array = []) {
  if (!Array.isArray(array)) return [];

  const recurse = (items) => {
    return items.flatMap(item => {
      const { children, ...rest } = item;
      return [rest, ...(Array.isArray(children) ? recurse(children) : [])];
    });
  };

  return recurse(array);
}




export const formatRelativeTime = (timestamp) => {
  const now = new Date();
  const time = new Date(timestamp);

  const diffInSeconds = Math.floor((now - time) / 1000);

  // Check if same day
  const isToday =
    now.getDate() === time.getDate() &&
    now.getMonth() === time.getMonth() &&
    now.getFullYear() === time.getFullYear();

  if (isToday) {
    if (diffInSeconds < 10) {
      return "Just now";
    }

    if (diffInSeconds < 60) {
      return `${diffInSeconds} second${diffInSeconds !== 1 ? "s" : ""} ago`;
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} minute${diffInMinutes !== 1 ? "s" : ""} ago`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    return `${diffInHours} hour${diffInHours !== 1 ? "s" : ""} ago`;
  }

  const formattedDate = `${time.getFullYear()}-${String(time.getMonth() + 1).padStart(2, '0')}-${String(time.getDate()).padStart(2, '0')} ${String(time.getHours()).padStart(2, '0')}:${String(time.getMinutes()).padStart(2, '0')}`;

  return formattedDate;
};